<template>
	<vs-prompt
    @update:active="activeProp = $event"
    :active="activeProp"
		:buttons-hidden="true"
		:title="$t('reassignAuthor')"
    :cancel-text="$t('cancel')"
    :class="userRole"
    color="warning"
		class="reassign-popup"
    button-cancel="filled"
    @cancel="close"
    @close="close"
	>
		<div class="vx-row mt-4 md:mt-0 justify-center sm:justify-start">
			<div class="vx-col w-full lg:w-1/2">
				<div class="vx-row flex flex-col items-start">

					<!-- Поле "Причина" -->
					<div class="vx-col w-full">
						<label class="vs-input--label">{{ $t('reassignReason') }}</label>
						<div class="vs-con-input"></div>
						<v-select
							v-model="form.reason"
							v-validate="'required'"
							:reduce="item => item.value"
							label="name"
							name="reason"
							:options="reasons"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:clearable="true"
							class="single-row-select"
						/>
						<p class="text-xs" style="color: #a9a9a9">
							{{ $t('chooseAuthorReassignReason') }}
						</p>
						<span
							:class="{ 'text-transparent': !errors.first('reason')}"
							class="text-danger text-sm"
						>
							{{ $t('requiredField') }}
						</span>
					</div>


					<!-- Поле "Комментарий" -->
					<div class="vx-col w-full">
						<label class="vs-input--label">{{ $t('comment') }}</label>
						<vs-textarea
							class="text-area"
							v-model="form.comment"
							name="comment"
							v-validate="'required|min:10'"
							:placeholder="$t('shareDetailsAboutReassign')"
						/>
						<span
							:class="{ 'text-transparent': !errors.first('comment')}"
							class="text-danger text-sm"
						>
						  {{ $t('requiredField') }}
						</span>
					</div>

					<!-- Чекбокс "Штраф" -->
					<div class="vx-col w-full">
<!--						<vs-select-->
<!--							:label="$t('needPenalty')"-->
<!--							name="penalty"-->
<!--							data-vv-name="penalty"-->
<!--							v-model="form.penalty"-->
<!--							v-validate="'required'"-->
<!--						>-->
<!--							<vs-select-item value="true" :text="$t('yes')"/>-->
<!--							<vs-select-item value="false" :text="$t('no')"/>-->

<!--						</vs-select>-->

						<label class="vs-input--label">{{ $t('needPenalty') }}</label>
						<div class="vs-con-input"></div>
						<v-select
							v-model="form.penalty"
							v-validate="'required'"
							:reduce="item => item.value"
							label="name"
							name="penalty"
							:options="penalty"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							:clearable="true"
							class="single-row-select"
						/>
						<span
							:class="{ 'text-transparent': !errors.first('penalty')}"
							class="text-danger text-sm"
						>
						  {{ $t('requiredField') }}
						</span>
					</div>

				</div>

				</div>
			</div>

      <div class="author-table" v-if="orderStatus != 'waiting_payment'">
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
            <div
              class="vs-component w-full vs-con-input-label vs-input vs-input-primary"
            >
              <label class="vs-input--label">{{ $t('level') }}</label>
              <div class="vs-con-input"></div>
              <v-select
                v-model="levelAuthor"
                name="level"
                label="level"
                :reduce="(levels) => levels.id"
                :options="levels"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-5">
            <div
              class="vs-component  w-full vs-con-input-label vs-input vs-input-primary"
            >
              <label class="vs-input--label">{{ $t('subjectArea') }}</label>
              <div class="vs-con-input"></div>
              <v-select
                v-model="subjectAuthor"
                :reduce="(subjects) => subjects.id"
                :options="subjects"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                name="work"
                label="name"
                class="single-row-select"
              />
            </div>
            <span class="text-danger text-sm">{{
                errors.first("work")
              }}</span>
          </div>
          <div class="vx-col w-full mb-3 search">
            <vs-input
              v-model="searchAuthor"
              icon="search"
              icon-after
              :placeholder="$t('searchByNameAndClient')"
              class="w-full"
            />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <div class="table-container">

              <vs-table multiple v-model="selected"  :data="authors">
                <template slot="thead">
                  <vs-th>
                    {{ $t('author') }}
                  </vs-th>
                  <vs-th>
                    {{ $t('status') }}
                  </vs-th>
                  <vs-th>
                    {{ $t('totalWorks') }}
                  </vs-th>
                  <vs-th>
                    {{ $t('currentVsLimit') }}
                  </vs-th>
                  <vs-th>
                    {{ $t('priceForNative') }}, €
                  </vs-th>
                  <vs-th>
                    {{ $t('favorites') }}
                  </vs-th>
                </template>
                <template slot-scope="{data}">
					<vs-tr
						v-for="(tr, indextr) in data"
						:key="indextr"
						:data="tr"
						:class="[
							{ problem: tr.is_problem },
							{ 'over-limit': tr.order_limit !== null && tr.orders_active_count >= tr.order_limit },
							{ 'undesirable_subject': tr.undesirable_subjects && tr.undesirable_subjects.includes(orderSubject)}
						]"
					>
                    <vs-td :data="data[indextr].first_name + data[indextr].last_name">
                      <RouterLink :to="`/${pathToAuthor}/${data[indextr].id}`">
                        <div class="flex item-center">
                          <div class="author-photo">
                            <img :src="data[indextr].photo">
                          </div>
                          <div class="author-name whitespace-no-wrap" style="max-width: 240px; overflow: hidden; text-overflow: ellipsis">
                            {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                          </div>
                        </div>
                      </RouterLink>
                    </vs-td>
                    <vs-td :data="data[indextr].status">
                      {{ publicStatus(data[indextr].status) }}
                    </vs-td>

                    <vs-td :data="data[indextr].orders_count">
                      {{data[indextr].orders_count}}
                    </vs-td>

                    <vs-td :data="data[indextr].orders_active_count">
                      {{data[indextr].orders_active_count}} / {{data[indextr].order_limit}}
                    </vs-td>

                    <vs-td :data="data[indextr].native_page_price">
                      <div v-if="data[indextr].quality_level === 1">
                        {{+data[indextr].native_page_price || ''}}
                      </div>
                    </vs-td>

                    <vs-td :data="data[indextr].is_favorite">
                      <div
                        @click.stop="toggleFavorite(data[indextr])"
                        class="select-author__favorite"
                      >
                        <img
                          v-if="!data[indextr].is_favorite"
                          src="@/assets/images/svg/star.svg"
                        >
                        <img
                          v-if="data[indextr].is_favorite"
                          src="@/assets/images/svg/filled-star.svg"
                        >
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </div>
			<div class="vx-row justify-end mt-5 mr-2 pb-2">
				<vs-button color="primary" @click="submitForm">
					{{ $t('reassign') }}
				</vs-button>
				<vs-button color="#9a9a9a" type="flat" @click="close" class="ml-2">{{
						$t("cancel")
					}}</vs-button>
			</div>
	</vs-prompt>

</template>

<script>
import axios from 'axios';
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from "vue-select";
import ConfirmMarginalityAction from "@/components/dialogs/ConfirmMarginalityAction.vue";
import {required} from "vee-validate/dist/rules.esm";

export default {
	name: "AuthorSelectReasignPopUp",
	mixins: [databaseManager, notifier],
	props: {
		active: { default: false, type: Boolean },
		orderId: { type: Number },
		levels: { default: [] },
		subjects: { default: [] },
		marginalityState: { default: false },
    	orderStatus: { required: true, type: String, default: '' },
		orderSubject: { type: Number },
	},
	components: {
		vSelect,
		ConfirmMarginalityAction
	},
	data() {
		return {
			levels: {
				type: Array,
				default: () => []
			},
			subjects: {
				type: Array,
				default: () => []
			},
			authorsSelectPopup: false,
			searchAuthor: '',
			requests: [],
			subjectAuthor: '',
			levelAuthor: '',
			selected: [],
			authors: [],
			marginalityPopupState: false,
			authorIdToSet: null,
			isMarginalityLow: false,
			actionFunction: null,
			isLoading: false,
			form: {
				reason: '',
				comment: '',
				penalty: null,
			},
		};
	},
	watch: {
		active(newValue) {
			if (newValue) {
				this.fetchAuthors();
			}
		},
		authorsSelectPopup(newValue) {
			if (newValue === false) {
				this.selected = [];
				this.searchAuthor = '';
				this.subjectAuthor = '';
				this.levelAuthor = '';
			}
		},
		searchAuthor() {
			this.updateList();
		},
		levelAuthor() {
			this.updateList();
		},
		subjectAuthor() {
			this.updateList();
		}
	},
	computed: {
		required() {
			return required
		},
		pathToAuthor() {
			const role = this.$store.state.auth.role;
			if (role === "manager") {
				return "authorM"
			} else if (role === "admin") {
				return "author";
			}
		},
		activeProp: {
			get() {
				return this.active;
			},
			set(value) {
				this.$emit("update:active", value);
			},
		},
    userRole() {
			return this.$store.state.auth.role;
		},
		reasons() {
			return [
				{
					name: this.$t('qualityIssue'),
					value: 'quality_issue',
				},
				{
					name: this.$t('lateness'),
					value: 'lateness',
				},
				{
					name: this.$t('authorsRequest'),
					value: 'authors_request',
				},
				{
					name: this.$t('unableToCompleteOrder'),
					value: 'unable_to_complete',
				},
				{
					name: this.$t('instructionsNotFollowed'),
					value: 'instructions_not_followed',
				},
				{
					name: this.$t('AI'),
					value: 'ai',
				},
				{
					name: this.$t('plagiarism'),
					value: 'plagiarism',
				},
				{
					name: this.$t('other'),
					value: 'other',
				},
			];
		},
		penalty() {
			return [
				{
					name: this.$t('yes'),
					value: true,
				},
				{
					name: this.$t('no'),
					value: false,
				},
			];
		}
	},
	methods: {
		async submitForm() {
			try {
        const isValid = await this.$validator.validateAll();

        if (!this.form.reason || !this.form.comment || this.form.penalty === null) {
          return;
        }

        const payload = {
          reason: this.form.reason,
          comment: this.form.comment,
          penalty: this.form.penalty,
          order_id: this.orderId
        }

				await this.dbDeleteAuthorFromOrder(this.orderId, payload);

        try{
          let promises = [];

          if (this.orderStatus !== 'waiting_payment') {
            for(let author of this.selected) {
              promises.push(this.dbInviteAuthor(this.orderId, author.id));
            }
          }

          await Promise.all(promises);

          this.notifySuccess(this.$t('yourRequestsWasSentSuccessfully'));

        }catch (e) {
          this.notifyError(e.message);
        }

				this.$emit('cancel');

				this.form = { reason: '', comment: '', penalty: null };
				this.selected = [];

				setTimeout(() => {
					location.reload();
				}, 300);
			} catch (error) {
				console.error(error);
			}
		},
    changeRequestFavorite(userId, value) {
			const request = this.requests.find(item => item.author.user_id === userId);

			if (!!request) {
				request.is_favorite = value;
			}
		},
		publicStatus(status) {
			const mapping = {
				'new': 'New registration',
				'assign': 'Assign',
				'assign_newbie': 'Assign (newbie)',
				'not_assign': 'Do NOT assign',
				'risk_zone_low': 'Risk zone - low',
				'risk_zone_medium': 'Risk zone - medium',
				'risk_zone_high': 'Risk zone - high',
				'probation': 'Probation',
				'to_be_deleted': 'To be deleted',
			};
			return mapping.hasOwnProperty(status) ? mapping[status] : 'New registration';
		},
		async toggleFavorite(author) {
			try {
				const newValue = !author.is_favorite;
				author.is_favorite = newValue;

				if (newValue === true) {
					await this.dbAddAuthorToFavorite(author.id);
				} else {
					await this.dbDeleteAuthorFromFavorite(author.id);
				}

				this.sortAuthors();
				this.changeRequestFavorite(author.user_id, newValue);
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async setPopupAction() {
			if (this.actionFunction === 'setAuthor') {
				await this.setAuthor()
			} else if (this.actionFunction === 'inviteAuthors') {
				await this.inviteAuthors()
			}

			this.actionFunction = null
		},
		async checkBeforeInviteAuthors() {
			if (this.marginalityState) {
				this.marginalityPopupState = true
				this.actionFunction = 'inviteAuthors'
			} else {
				await this.inviteAuthors()
			}
		},
		close() {
			this.activeProp = false;
      this.form = {
        reason: '',
        comment: '',
        penalty: null,
      },
			this.$emit("cancel");
		},
		async setAuthor() {
			this.isLoading = true

			try {
				if (this.isMarginalityLow) {
					await this.dbCreateMarginalityTask(this.orderId);
					this.isMarginalityLow = false
				}
				await this.dbSetAuthor(this.orderId, this.authorIdToSet);
				this.notifySuccess(this.$t('youHaveAssignedAuthorToThisProject'));
				await this.$emit("updateModel");
				await this.$emit("updateStages");
				await this.$emit("updateAuthor");
				this.authorIdToSet = null

			} catch (e) {
				this.notifyError(e.message);
			} finally {
				this.isLoading = false
			}
		},
		sortAuthors() {
			this.authors.sort((a, b) => {
				if (b.is_favorite) {
					return 1;
				} else if (a.is_favorite === true) {
					return -1;
				} else {
					return 0;
				}
			});
		},
		async updateList() {
			try {
				const options = {
					name: this.searchAuthor !== '' ? this.searchAuthor : undefined,
					level: Number.isInteger(this.levelAuthor) ? this.levelAuthor : undefined,
					subject: Number.isInteger(this.subjectAuthor) ? this.subjectAuthor : undefined
				};

				const res = await this.dbGetAuthorInviteList(options);
				this.authors = res || [];
				this.sortAuthors();
			} catch (e) {
				this.notifyError(e.message);
			}
		},
		async fetchAuthors() {
			const role = this.$store.state.auth.role;
			await this.updateList();
			if (role === 'manager' || role === 'admin') {
				const requestsUrl = `/${role}/order/get-author-requests/${this.$route.params.id}`;
				const requestsRes = (await this.$http.get(requestsUrl));
				this.requests = requestsRes.data.data;
			}
		}
	},
	async mounted() {
		await this.fetchAuthors();
	}
};
</script>


<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.reassign-popup {
  .vs-dialog {
    max-width: 60rem;
    max-height: 50rem;
    overflow-y: auto;
    overflow-x: hidden;
  }

  .con-select {
    width: 100%;
  }
  .vs-textarea {
    height: 6rem;
    margin-bottom: 0;
  }
  .vs-textarea::placeholder {
    color: darkgrey;
    font-size: 12px;
  }

  .vs-popup {
    max-height: 100%;
    padding: 0 15px !important;
    max-width: 800px !important;
    width: 100% !important;

    &--content{
      width: 100%;
      height: 100%;
      padding: 13px 0;
      overflow: auto;
    }

    .vx-row {
      margin-left: 0;
    }
  }
  .vs-dialog-cancel {
    position: absolute;
    top: 5px;
    right: 10px;
  }
  .vs-con-table {
    background: #f8f8f8;
    border: 2px solid #f8f8f8;
    max-height: 10rem;
    overflow-y: auto;
    .vs-con-tbody {
      background: none;
      border: none;
    }
  }

  .author-photo {
    width: 25px;
    height: 25px;
    border-radius: 100%;
    overflow: hidden;
    margin-right: 6px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .author-name {
    color: $primary;
    text-decoration: underline;
  }

  .input-search {
    border: rgba(60, 60, 60, 0.26) 1px solid !important;
    border-radius: 4px;
  }

  .select-author__favorite {
    width: 25px;
    height: 25px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .search .vs-icon {
    height: 100%;
    width: 35px;
    background: $primary;
    position: absolute;
    top: 0;
    right: 0;
    color: white !important;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    font-size: 22px;
  }

  .author-search-requests {
    &__photo {
      flex: 30px 0 0;
    }
  }
  tr {
    &.problem {
      background: #ea545481 !important;
    }
	  &.over-limit {
		  background: #ea545481 !important;
	  }
	  &.undesirable_subject {
		  background: #ea545481 !important;
	  }
  }
  .table-container {
    max-height: 300px;
    overflow-y: auto;
  }
}

</style>

